module.exports = __webpack_public_path__ + "static/media/ic-good-nor.e4edb1c0.svg";